/* eslint-disable class-methods-use-this */
import React from 'react';
import { createRoot } from 'react-dom/client';
import ErrorBoundary from 'react/components/error_boundary';

class AbstractPack {
  constructor() {
    this.reactRoots = new Map();
  }

  wrapWithErrorBoundary(element) {
    return React.createElement(ErrorBoundary, {}, element);
  }

  renderReactComponent(containerId, maybeProps, component) {
    const elem = document.getElementById(containerId);
    if (!elem) { return; }
    const props = maybeProps ||
      (elem.dataset.props && JSON.parse(elem.dataset.props)) ||
      {};
    const reactElement = this.wrapWithErrorBoundary(React.createElement(component, props));

    if (this.reactRoots.has(containerId)) {
      this.reactRoots.get(containerId).render(reactElement);
    } else {
      const root = createRoot(elem);
      root.render(reactElement);
      this.reactRoots.set(containerId, root);
    }
  }

  renderReactComponents(selector, component) {
    const elementList = document.body.querySelectorAll(selector);

    Array.prototype.forEach.call(elementList, (element) => {
      const props = JSON.parse(element.dataset.props);
      const reactElement = this.wrapWithErrorBoundary(React.createElement(component, props));
      const elementKey = element.id || `${selector}-${Math.random()}`;

      if (this.reactRoots.has(elementKey)) {
        this.reactRoots.get(elementKey).render(reactElement);
      } else {
        const root = createRoot(element);
        root.render(reactElement);
        this.reactRoots.set(elementKey, root);
      }
    });
  }
}

export default AbstractPack;